import { Component, OnInit, Inject } from '@angular/core';
import {Router} from "@angular/router"
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import { MatDialog} from '@angular/material/dialog';
import { environment } from '../../../environments/environment';
import { DlgTrabajandoComponent } from '../../components/dlg-trabajando/dlg-trabajando.component';
import { DlgErrorComponent } from '../../components/dlg-error/dlg-error.component';
import {MatDialogRef} from '@angular/material/dialog';
import { DlgAvisoComponent } from '../../components/dlg-aviso/dlg-aviso.component';
import { DlgBusquedasComponent } from '../../components/dlg-busquedas/dlg-busquedas.component';

@Component({
  selector: 'app-dlg-whats-app',
  templateUrl: './dlg-whats-app.component.html',
  styleUrls: ['./dlg-whats-app.component.css']
})
export class DlgWhatsAppComponent implements OnInit {

  titulo="";
  idWhatsAPP="";
  txtWhatsAPP="";

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private httpClient: HttpClient,
    @Inject(SESSION_STORAGE) private storage: StorageService,
    public thisDialogRef: MatDialogRef<DlgWhatsAppComponent>,
  ) { }

  ngOnInit(): void {
  }

  cerrarDialogo(dialogoActual) {
    dialogoActual.close();
  }

  cerrar(cadena) {
    this.thisDialogRef.close({mensaje: cadena, idWhatsAPP: this.idWhatsAPP
      ,txtWhatsAPP: this.txtWhatsAPP
    });
  }

  almacenar(){
    if (this.txtWhatsAPP==""){
      let dlgError = this.dialog.open(DlgErrorComponent, {
        width: '600px',
        disableClose:true
      });
      dlgError.componentInstance.titulo="Error al almacenar el WhatsAPP";
      dlgError.componentInstance.texto="Le falto indicar el Nº de WhatsAPP";
      return;
    }
    this.cerrar('almaceno');
  }
}
